export default __webpack_public_path__ + "static/media/bg-pattern-card.b61daebd.svg";